function createNotificate(objectId) {
  var control = $(this);
  $.ajax({
    url: Url.action('api/notifications/unreaded'),
    type: 'POST'
  })
  .success(function (result) {
    // Обновление кол-ва сообщений в меню
    $('#newNotifications').html(result && result > 0 ? '<span class="label label-warning">' + result + '</span>' : '');

    // Вывод уведомления он новых сообщениях
    toastr.options = {
      closeButton: true,
      debug: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      onclick: null,
      showDuration: 400,
      hideDuration: 1000,
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    $('toast-close-button').on('click', function () {
      toastr.clear();
    });

    var msg = window.location.pathname == Url.action('notifications') ? '<a id="notificationReload">Обновить</a>' :'<a href="'+Url.action('notifications')+'">Перейти к уведомлениям</a>';
    var $toast = toastr['success'](msg, 'У вас есть новые уведомления.');

    $('#notificationReload').on('click', function () {
      $('#NotificationsListItemViewModelTable').DataTable().ajax.reload(null, false);
    })
  })
  .error(function (xhr, status, statusCode) {
    console.error(status + ': ' + statusCode);
  });
};
